import { useCallback, useEffect, useMemo, useState } from 'react';
import { AgendaS } from '../restapi/taskService';

// eslint-disable-next-line import/prefer-default-export
export const useOverdueTasks = () => {
  const [count, setCount] = useState(0);

  const refresh = useCallback(async () => {
    const overdueCount = await AgendaS.fetchOverdueCount();
    setCount(overdueCount);
    return overdueCount;
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const increment = useCallback(() => {
    setCount((currentCount) => currentCount + 1);
  }, []);

  const decrement = useCallback(() => {
    setCount((currentCount) => Math.max(currentCount - 1, 0));
  }, []);

  return useMemo(() => ({ count, refresh, increment, decrement }), [count, refresh, increment, decrement]);
};
